import AddCircleIcon from '@mui/icons-material/AddCircle';
import CloseIcon from '@mui/icons-material/Close';
import { Avatar, IconButton, Typography } from '@mui/material';
import { Box, Container, Stack } from '@mui/system';

import React, { useCallback, useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import moment from 'moment';
import { useForm } from 'react-hook-form';

import ButtonComp from 'common/components/Button/ButtonComp';
import { HTTP_STATUS_CODES } from 'common/constants/HttpStatusConstants';
import { setToastMessage } from 'common/store/reducer/commonReducer';

import { editUser, getAllGroups } from '../api';
import { IEditUserFormProps, IEditUserParams, IUser } from '../api/type-def';
import GroupRolesList from '../GroupRolesList';
import GroupsList from '../GroupsList';

import ChipComponent from '../../../../common/components/Chip/Chip';
import ModalEle from '../../../../common/components/Modal/ModalEle';
import SwitchComp from '../../../../common/components/Switch/SwitchComp';
import { UserStatus } from '../../../../common/constants/UserManagementConstants';

import styles from './EditUser.module.scss';

export interface IEditDataProps {
	firstName: string;
	lastName: string;
	groups: any[];
	email: string;
	userEndDate: string;
	email_address: string;
	status: string;
}
interface EditProps {
	data: IUser;
	onCloseModal: () => void;
}
const EditUser = ({ data, onCloseModal }: EditProps) => {
	const { ACTIVE, INACTIVE } = UserStatus;
	const { INTERNAL_SERVER_ERROR } = HTTP_STATUS_CODES;
	const { firstName, lastName, email, userEndDate, status, userId } = data;
	const editGroups: any = data?.groups;
	const [editGroupsData, setEditGroupsData] = useState<any[]>([]);
	const [groups, setGroupData] = useState<any[]>([]);
	const [groupRolesData, setGroupRoles] = useState<any[]>([]);
	const [isChecked, setIsChecked] = useState(status === ACTIVE);
	const [statusChange, setStatusChange] = useState<string>(status);
	const [switchChange, setIsSwitchChanged] = useState(false);
	const [isLoading, setLoading] = useState(false);

	const [defaultformValues, setDefaultformValues] =
		useState<IEditUserFormProps>({
			firstName,
			lastName,
			groups: [],
			userEndDate,
			email,
			status,
			userId,
			roles: [],
		});
	const {
		handleSubmit,
		control,
		getValues,
		setValue,
		watch,
		formState: { isDirty, isValid },
	} = useForm<IEditUserFormProps>({
		mode: 'onChange',
		defaultValues: defaultformValues,
	});

	const watchGroups = watch('groups', []);
	const onGroupSelect = () => {
		const newArray: any[] = [];
		if (watchGroups.length > 0) {
			watchGroups.forEach((ele: any) => {
				newArray.push(ele);
				if (groupRolesData.length === 0) {
					setGroupRoles([...newArray]);
				} else {
					const res = newArray.filter((item1: any) => {
						newArray.push(ele);
						return !groupRolesData.some(
							(item2: any) => item2?.groupName === item1?.groupName,
						);
					});
					setGroupRoles([...groupRolesData, ...res]);
				}
			});
		} else {
			const newArr: any[] = [];
			setGroupRoles([...groupRolesData, ...newArr]);
		}
	};
	// deletegrouplist
	const onChipDelete = useCallback((data: any) => {
		const obj = data?.option;
		const res = groupRolesData.filter(
			(item2: any) => item2?.groupName !== obj?.groupName,
		);
		setGroupRoles([]);
		setGroupRoles([...res]);
	}, []);
	const date = new Date(userEndDate).toLocaleDateString('en-US', {
		day: 'numeric',
		month: 'short',
		year: 'numeric',
	});

	const switchHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
		setIsChecked(event.target.checked);
		setIsSwitchChanged(!switchChange);
	};

	// users update

	const dispatch = useDispatch();
	const buildPayload = (data: any) => {
		const paramsObj: IEditUserParams = {} as IEditUserParams;
		const tempGroups: any = data?.groups;

		const allRoles: any = [];

		const groupsInfo = tempGroups?.map((ele: any) => {
			const groupObj: any = {};
			groupObj.groupId = ele?.groupId;
			groupObj.groupName = ele?.groupName;
			if (ele?.roles && ele?.roles.length > 0) {
				ele?.roles.forEach((role: any) => {
					const roleObj: any = {};
					roleObj.roleId = role?.roleId;
					roleObj.roleName = role?.roleName;
					allRoles.push(roleObj);
				});
			}
			return groupObj;
		});

		paramsObj.firstName = data?.firstName;
		paramsObj.lastName = data?.lastName;
		paramsObj.groups = groupsInfo;
		paramsObj.userEndDate = '';
		paramsObj.email = data?.email;
		paramsObj.userName = data?.email;
		paramsObj.userId = data?.userId;
		paramsObj.status = statusChange;
		paramsObj.roles = allRoles;
		return paramsObj;
	};
	const saveHandler = useCallback(async () => {
		const addUserFormvalues = getValues();

		const payload: any = {
			...buildPayload(addUserFormvalues),
		};

		const response = await editUser(payload);
		if (response.responseBody) {
			onCloseModal();
			dispatch(
				setToastMessage({
					message: 'The user has been successfully edited',
					severity: 'success',
					isToastOpen: true,
				}),
			);
		}
		if (response.statusCode === INTERNAL_SERVER_ERROR) {
			dispatch(
				setToastMessage({
					message:
						"We're sorry, but we're unable to process your edit user request at the moment. Please try again later.",
					severity: 'error',
					isToastOpen: true,
				}),
			);
		}
	}, [statusChange]);

	const handleDateChange = useCallback((data: any) => {
		setValue('userEndDate', moment(data).format('YYYY-MM-DD'));
	}, []);
	const [showAddGroup, setShowAddGroup] = useState(false);
	const [addGrpBtn, setAddGrpBtn] = useState(true);
	const addGroupHandler = useCallback(() => {
		setShowAddGroup(!showAddGroup);
		setAddGrpBtn(!addGrpBtn);
	}, [addGrpBtn, showAddGroup]);

	const setEdittedGroupsData = (tempRespGroups: any) => {
		const selectedGroupName: any[] = [];
		if (tempRespGroups && tempRespGroups.length > 0) {
			tempRespGroups.forEach((groupInfo: any) => {
				if (editGroups && editGroups.length > 0) {
					editGroups.forEach((ele: any) => {
						if (ele?.groupId === groupInfo?.groupId) {
							selectedGroupName.push(groupInfo);
						}
					});
				}
			});
		}

		setEditGroupsData(selectedGroupName);
	};
	const getGroupsData = async () => {
		const grpresponse = await getAllGroups();
		if (grpresponse?.responseBody) {
			const tempGroups: any[] = grpresponse.responseBody;
			const tempRespGroups: any = [];
			tempGroups?.forEach((ele: any) => {
				const tempObj = ele;
				tempObj.isOpen = true;
				const roles = tempObj?.roles;
				if (roles && roles.length > 0) {
					roles.forEach((iRole: any) => {
						iRole.endDate = new Date();
					});
				}
				tempObj.roles = roles;
				tempRespGroups.push(tempObj);
			});

			setGroupData(tempRespGroups);
			setEdittedGroupsData(tempRespGroups);
			setLoading(false);
		}
		setLoading(false);
	};

	useEffect(() => {
		setLoading(true);
		getGroupsData();
	}, []);
	useEffect(() => {
		if (watchGroups && watchGroups.length > 0) {
			onGroupSelect();
		}
	}, [watchGroups]);
	useEffect(() => {
		if (editGroupsData.length) {
			setValue('groups', editGroupsData);
			setDefaultformValues((prevState: any) => ({
				...prevState,
				groups: editGroupsData,
			}));
		}
	}, [editGroupsData]);
	useEffect(() => {
		if (isChecked) {
			setStatusChange(ACTIVE);
		} else {
			setStatusChange(INACTIVE);
		}
	}, [isChecked]);

	return (
		<ModalEle open handleClose={onCloseModal}>
			<Container
				className={styles['edit-user']}
				data-testid="edit-user-container"
			>
				<Stack
					direction="row"
					justifyContent="space-between"
					className={styles['edit-user-label']}
				>
					<Typography className={styles['header-text']}>Edit User</Typography>
					<Stack direction="row" justifyContent="end">
						<IconButton onClick={onCloseModal}>
							<CloseIcon fontSize="medium" />
						</IconButton>
					</Stack>
				</Stack>
				<Box className={styles['edit-user-box']}>
					<Stack direction="row" justifyContent="space-between" spacing={2}>
						<Stack direction="row">
							<Avatar className={styles['user-avatar']}>
								{`${firstName.charAt(0)}${lastName.charAt(0)}`}
							</Avatar>
							<Box className={styles['name-box']}>
								<Stack
									direction="column"
									className={styles['user-column']}
									alignItems="start"
								>
									<Typography className={styles['user-name-column']}>
										{`${firstName} ${lastName}`}
									</Typography>
									<Typography className={styles['user-email-column']}>
										{email}
									</Typography>
									<Typography className={styles['user-edit-column']}>
										{`Last active ${date}`}
									</Typography>
								</Stack>
							</Box>
						</Stack>
						<Stack
							direction="row"
							justifyContent="end"
							className={styles['edit-user-state']}
						>
							<Typography className={styles['edit-user-status']}>
								Status:
							</Typography>
							<div className={styles['chip-style']}>
								<ChipComponent
									label={statusChange}
									customcolor={statusChange}
								/>
							</div>
							<SwitchComp
								label=""
								value={isChecked}
								onChange={switchHandler}
								data-testId="switch-active"
							/>
						</Stack>
					</Stack>
					{isChecked && !isLoading && (
						<Box>
							<Stack className={styles['group-data']}>
								<div>
									<GroupRolesList
										data={groupRolesData}
										handleDateChange={handleDateChange}
										testId="roles-test-id"
									/>
								</div>
							</Stack>
							<Stack
								direction="row"
								justifyContent="flex-end"
								className={styles['add-grp-section']}
							>
								{addGrpBtn ? (
									<ButtonComp
										btnType="secondary"
										disableRipple
										compClass={styles['add-group-btn']}
										data-testid="add-groups-btn"
										clickHandler={addGroupHandler}
									>
										<AddCircleIcon className={styles['add-icon-style']} />
										Add to groups
									</ButtonComp>
								) : (
									<ButtonComp
										btnType="secondary"
										disableRipple
										compClass={styles['add-group-btn']}
										data-testid="cancel-groups-btn"
										clickHandler={addGroupHandler}
									>
										<AddCircleIcon className={styles['close-icon-style']} />
										Cancel
									</ButtonComp>
								)}
							</Stack>
							<Box>
								{showAddGroup && (
									<GroupsList
										data={groups}
										type="groups"
										key="groups"
										onDelete={onChipDelete}
										control={control}
										selectedGroups={groupRolesData}
									/>
								)}
							</Box>
						</Box>
					)}
				</Box>
			</Container>
			<form onSubmit={handleSubmit(() => {})}>
				<Box className={styles['btn-box']}>
					<Stack
						direction="row"
						justifyContent="flex-end"
						className={styles['btn-grp']}
					>
						<ButtonComp btnType="secondary" clickHandler={onCloseModal}>
							Cancel
						</ButtonComp>
						<ButtonComp
							clickHandler={saveHandler}
							data-testid="edit-user-submit"
							btnType="primary"
							disabled={
								groupRolesData.length < 1 ||
								((!isDirty || !isValid) && !switchChange)
							}
						>
							Save
						</ButtonComp>
					</Stack>
				</Box>
			</form>
		</ModalEle>
	);
};
export default EditUser;
